module.exports = __webpack_public_path__ + "static/media/mode-514.3228e8d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-514.svg
// module id = 1062
// module chunks = 2